/**
 * categoryIcon — maps a category NAME to a Lucide icon for the header strip.
 *
 * Real categories from the API have names but no icon, while the header's
 * CategoryScroller is icon-based. This keyword mapping bridges the two so the
 * strip shows sensible icons for whatever categories a college actually has.
 */

import {
  Apple,
  Milk,
  Cookie,
  CupSoda,
  Coffee,
  Wheat,
  Candy,
  Sparkles,
  Croissant,
  House,
  ShoppingBasket,
} from 'lucide-react';

const RULES = [
  [/veg|fruit/i, Apple],
  [/dairy|milk|bread|egg|butter|cheese|curd/i, Milk],
  [/tea|coffee/i, Coffee],
  [/drink|beverage|juice|cola|soda|water/i, CupSoda],
  [/snack|munch|chip|namkeen/i, Cookie],
  [/staple|atta|rice|oil|dal|flour|sugar|grain|pulse/i, Wheat],
  [/choco|sweet|candy|biscuit|cookie/i, Candy],
  [/bakery|cake|croissant|bun/i, Croissant],
  [/care|personal|soap|shampoo|clean|groom|hygiene/i, Sparkles],
  [/home|household/i, House],
];

export function categoryIcon(name = '') {
  for (const [pattern, Icon] of RULES) {
    if (pattern.test(name)) return Icon;
  }
  return ShoppingBasket;
}

/** A short, single-word label so long category names fit the compact strip. */
export function categoryShortLabel(name = '') {
  const firstSegment = name.split(/[,&/]/)[0].trim();
  const firstWord = firstSegment.split(/\s+/)[0] ?? name;
  return firstWord.length > 11 ? firstWord.slice(0, 11) : firstWord;
}

export default categoryIcon;
